import { Route } from "../models/Route";

export const clientRoutes: Route[] = [
    {path: "/panel", icon: <> </> , navbarShow: false, regex:null, name:""},


    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]

export const adminRoutes: Route[] = [
    {path: "/", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/crear-producto", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/actualizar_producto/:id", icon: <> </> , navbarShow: false, regex:/^\/actualizar_producto\/\d+$/, name:""},



    {path: "/inventario", icon: <></>  , navbarShow: true, regex:null, name:"Inventario"},
    {path: "/orden", icon: <></>  , navbarShow: true, regex:null, name:"Ordenes"},
    {path: "/ajustes", icon: <></> , navbarShow: true, regex:null, name:"Configuración"},



    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]



export const nonRoutes: Route[] = [
    {path: "/", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/ingresar", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/productos", icon: <> </> , navbarShow: false, regex:null, name:""},
    {path: "/inicio", icon: <> </> , navbarShow: false, regex:null, name:""},

    // {path: "/frikistore", icon: <ShoppingOutlined /> , navbarShow: true, regex:null},
    // {path: "/sets", icon: <GiArchiveResearch /> , navbarShow: true, regex:null},
    // {path: "/cards/:id", icon: <GiArchiveResearch /> , navbarShow: false, regex:/^\/cards\/\d+$/},
    // {path: "/ingresar", icon: <TruckOutlined /> , navbarShow: false, regex:null},
    // {path: "/registro", icon: <TruckOutlined /> , navbarShow: false, regex:null},

]